import $ from 'cash-dom';


import './selectors';
import './cart';
import './checkout';
// import './facets';
// import './listing';
import './product';
import './address';
import "./components"

import {psShowHide} from './common';
import initEmailFields from './email-idn';

import popover from "./popover";

var dbg=window.prestashop.debug ;

if(!$.fn.popover){
  
  if(dbg) console.log('register popover');
  $.fn.popover = function(){
      return this.each(function(elem) {
        console.log('popover called on '+ elem);
        popover(elem);
      });
      return this;
  }
}


/*
(function () {
  function $(selector) {
    let elements;

    if (typeof selector === 'string') {
      elements = document.querySelectorAll(selector);
    } else if (selector instanceof Node) {
      elements = [selector];
    } else if (selector instanceof NodeList || Array.isArray(selector)) {
      elements = selector;
    } else {
      elements = [];
    }

    return {
      elements,

      each(callback) {
        this.elements.forEach((el, index) => callback.call(el, el, index));
        return this;
      },

      popover() {
        console.log('popover called');
        this.each((el, index) => {
          console.log('popover on', el);
          popover(el);
        });
        return this;
      },

        ready(callback) {
        if (elements.includes(document)) {
          onReady(callback);
        }
        return this;
      }
    };
  }
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      // already ready → run immediately (like jQuery)
      callback();
    }
  }
  // expose globally
  window.$ = $;
})();*/

$.post = function (url, data = {}, options = {}, dataType = 'json') {
   options = options || {};

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...(options.headers || {}),
  };

  // 👇 Tell backend we want JSON
  if (dataType === 'json') {
    headers['Accept'] = 'application/json';
  }

  const fetchOptions = {
    method: 'POST',
    headers,
    body: new URLSearchParams(data).toString(),
    ...options,
  };

  return fetch(url, fetchOptions).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }

    if (dataType === 'json') return response.json();
    if (dataType === 'blob') return response.blob();
    if (dataType === 'formData') return response.formData();
    return response.text();
  }).catch(error=>console.error(error)).finally(()=>console.log('done :'+url));
};


$.fn.submit = function (target) {
  // If target is not provided, use `this`
  let elements;

  if (!target) {
    elements = this;
  }
  // If target is already a Cash object
  else if (typeof target.each === 'function') {
    elements = target;
  }
  // If target is a DOM element
  else if (target instanceof HTMLElement) {
    elements = $(target);
  }
  // If target is a selector string
  else if (typeof target === 'string') {
    elements = $(target);
  }
  // fallback to empty collection
  else {
    elements = $([]);
  }

  return elements.each(function (el) {
    // Cash DOM passes (el, i) to the callback, but `this` is also the element
    const form = el || this;
    if (form && form.tagName === 'FORM') {
      const event = new Event('submit', { bubbles: true, cancelable: true });
      const canceled = !form.dispatchEvent(event);
      if (!canceled) {
        form.submit();
      }
    }
  });
};


$.ajax = function ({ url, method = 'GET', data, headers = {} }) {
  const options = {
    method,
    headers,
  };

  if (data) {
    if (method.toUpperCase() === 'GET') {
      url += '?' + new URLSearchParams(data).toString();
    } else {
      options.body = new URLSearchParams(data).toString();
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
  }

  return fetch(url, options).then((res) => res.json()).catch(error=>console.error(error));
};


$.fn.visible = function () {
  return this.filter(function () {
    return this && this.offsetParent !== null;
  });
};

$.fn.first = function () {
  return this.eq(0);
};

$.fn.serializeArray = function () {
  const result = [];

  this.each((form) => {
    if (form.tagName !== 'FORM') return;

    const formData = new FormData(form);

    formData.forEach((value, name) => {
      result.push({ name, value });
    });
  });

  return result;
};

window.$ = $;
window.jQuery = $;


$(document).ready(() => {
  psShowHide();
  initEmailFields('input[type="email"]');
});
